import React from 'react'
import Proptypes from 'prop-types'
import { View, TouchableOpacity } from 'react-native'
import { Badge } from 'react-native-elements'
import Txt from '../Txt'
import Icon from '../Icons'
const MultiselectedOption = ({ getOptionLabel, deselectOption, selectedOptions, nameProp, styles }) => (
  <View style={styles.multiselectedContainer}>
    {Boolean(selectedOptions && selectedOptions.length) && selectedOptions.map((option, key) => (
      <Badge
        key={key}
        badgeStyle={styles.multiselectedBadget}
        value={(
          <View style={styles.multiselectedOption}>
            <Txt
              text={getOptionLabel ? getOptionLabel(option) : option[nameProp]}
              style={styles.multiselectedText}
            />
            <TouchableOpacity activeOpacity={0.8} onPress={() => deselectOption(option)}>
              <Icon
                name='Times'
                width={12}
                height={12}
                style={styles.multiselectedIcon}
              />
            </TouchableOpacity>
          </View>
        )}
      />
    ))}
  </View>
)

MultiselectedOption.propTypes = {
  getOptionLabel: Proptypes.func,
  deselectOption: Proptypes.func,
  selectedOptions: Proptypes.array,
  nameProp: Proptypes.string,
  styles: Proptypes.object
}

MultiselectedOption.defaultProps = {
  getOptionLabel: null,
  deselectOption: () => {},
  selectedOptions: [],
  nameProp: ''
}

export default MultiselectedOption
